import Vue from "vue";
import App from "./App.vue";
import i18n from "@common/src/i18n/i18n";
import router from "./router";
import store from "./store";

import VueClipboard from "vue-clipboard2";
import Element from "element-ui";
import SpeedbizUi from "@gtech/speedbiz-ui";
import Directive from "@/extends/directive";
// sentry
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import "./assets/css/index.scss";
import "@common/src/assets/css/element-cover.scss";
import "@common/src/assets/css/common.scss";
import { safeValue } from "@common/src/utils/common";

import components from "@/components/global/index";
import common_components from "@common/src/components/index";
import message from "@/extends/message";
import localMark from "@common/src/extends/local-mark";
import Print from "vue-print-nb";
import "@/extends/prototype";

require("promise.prototype.finally").shim();
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    Vue,
    dsn: "https://e593231202fc4179bd0c9fdb6e37e908@sentry.gtech.asia/20",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  });
}

Vue.prototype.$safeValue = safeValue;
Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(components);

Vue.use(Directive);
Vue.use(localMark);
Vue.use(Print);
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(SpeedbizUi, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(common_components);
// 要在引入element之后覆盖
Vue.use(message);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
